package at.apa.statistictracker.db

import com.squareup.sqldelight.db.SqlDriver
import com.squareup.sqldelight.drivers.sqljs.initSqlDriver
import kotlin.js.Promise


@JsExport
object DriverFactory {
    fun createJsDriver(): Promise<Any> = initSqlDriver(StatisticTrackerDb.Schema)
}